import React from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import ProgressBar from 'react-bootstrap/ProgressBar';

const VerbProgressBar = ({ totalSteps, currentStep, withCount = false, className, containerClassName }) => {
    const percentage = totalSteps ? (currentStep / totalSteps) * 100 : 0;

    return (
        <div className={cns('verb-progress-bar-wrapper', containerClassName)}>
            <ProgressBar now={percentage} className={cns('verb-progress-bar', className)} />
            {withCount && (
                <p className={'verb-progress-bar-count'}>
                    {currentStep}/{totalSteps}
                </p>
            )}
        </div>
    );
};

VerbProgressBar.propTypes = {
    totalSteps: PropTypes.number.isRequired,
    currentStep: PropTypes.number.isRequired,
    withCount: PropTypes.bool,
    className: PropTypes.string,
    containerClassName: PropTypes.string
};

export default VerbProgressBar;
